//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'providerItem',
  props: ['resource', 'ratio', 'thumb', 'minimal'],
}
